import React from "react";

import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

import img1 from "../../logos/photos/shutterstock_2580352239.jpg"





export default function Preparedness() {

  
  return (
    <Layout>
      <Navbar  />
      <PageHeader />
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="about-content-left section-heading">
                <h4 style={{color:'#e95d04'}}>
                Enhancing Emergency Preparedness in Athens Through Digital Twin Technology
                                 </h4>
                <p>
              As part of the PANTHEON project, Athens is implementing innovative pilot scenarios to support
first responders in both operational planning and training, using Smart City Digital Twins
(SCDTs).
</p>
<h4><strong>Two Key Applications for First Responders</strong></h4>
<p>The PANTHEON platform addresses two primary needs identified within first responder organizations:</p>
<ol>
<li>Planning Scenarios: The platform presents comprehensive data to operators and enables adjustment of parameters to test the feasibility of existing standard operating procedures during crises. This includes decision support and resource management tools to optimise responses.<br /> </li>
<li>Training Augmentation: The platform serves as an enhancement to existing disaster relief education, providing a broad overview of simulation components. This encourages trainers to creatively integrate digital twin technology into their curricula.<br /> </li>
</ol>
<br/>
<h4><strong>Athens Pilot Scenario 1: Earthquake Response</strong></h4>
<p>The first pilot focuses on simulating the police response to an earthquake in the Athens metropolitan area. In accordance with the Civil Protection mechanism, the Hellenic Police are tasked with mobilising resources to ensure the safe evacuation of affected areas and responding to emergency calls, such as assisting elderly residents or managing road closures caused by building collapses.</p>
<p>The objective is to develop a deployment plan that strategically positions vehicles and mobile units across the city to minimize response times. The PANTHEON system is employed as a simulation tool to assist police staff in preparing for rapid mobilisation during such an event.</p>
<h4><strong>Athens Pilot Scenario 2: Wildfire Training in Fyli</strong></h4>
<p>The second pilot simulates a wildfire scenario in the suburb of Fyli, northwest Athens. This training exercise follows a three-step process:</p>
<ul>
<li>Presentation of a realistic wildfire scenario to law enforcement trainees.<br /> </li>
<li>Collection and analysis of the trainees&rsquo; responses.<br /> </li>
<li>Redefinition of the scenario incorporating the trainees&rsquo; actions, thereby illustrating the impact of their decisions.<br /> </li>
</ul>
<p>This methodology aligns with the Hellenic Police&rsquo;s established hands-on training practices, reinforcing their role in ensuring timely evacuation, resource mobilisation, and emergency response during wildfires.</p>
<h4><strong>Advancing Preparedness Through Innovation</strong></h4>
<p>These pilot scenarios highlight how the PANTHEON platform can enhance both the planning and training capabilities of first responders. Using advanced simulation technology, Athens is taking important steps&nbsp; to strengthen disaster response and boost community safety.</p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="about-content-right">
                <img
                  src={img1}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />
          
              </div>
            </div>
          </div>
        </div>
      </section>
  

      <Footer space />
    </Layout>
  );
}
